// Action Types
export const ADD_RECENT_SEARCH = 'recentSearches/ADD_RECENT_SEARCH';
export const DISMISS_COACHMARK = 'recentSearches/DISMISS_COACHMARK';

// Action Creators
export const addRecentSearch = (params, savedOffers) => ({
  type: ADD_RECENT_SEARCH,
  payload: { params, savedOffers },
});

export const dismissCoachmark = () => ({
  type: DISMISS_COACHMARK,
});
